<template>
  <div class="hero">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h1>{{ `${this.$i18n.t("navBar." + page)}` }}</h1>
          <img
            src="https://res.cloudinary.com/yanfomaweb/image/upload/v1587965268/afrikeveil/hero-line.png"
            alt
          />
          <ul class="breadcumb">
            <li>
              <router-link
                :to="{ name: `${this.$i18n.t('routes.' + previous)}` }"
              >{{ `${this.$i18n.t("navBar." + previous)}` }}</router-link>
            </li>
            <li>
              <span>/</span>
              {{ `${this.$i18n.t("navBar." + page)}` }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BreadsCrums",
  props: {
    page: String,
    previous: String
  }
};
</script>

<style scoped lang="scss">
.hero {
  padding: 30px;
  margin-bottom: 30px;
  background: #228c4f;
  background-position: center;
  text-align: center;
  background-size: cover;
  position: relative;
}
.hero ul.breadcumb span {
  margin-left: 15px;
  margin-right: 15px;
}
.hero h1 {
  font-family: "Josefin Sans", sans-serif;
  font-size: 42px;
  color: #f9f9f9;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 1.5;
}
.hero ul.breadcumb {
  list-style-type: none;
  margin-top: 10px;
}
.hero ul.breadcumb li,
.hero ul.breadcumb a {
  display: inline-block;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #f9f9f9;
  font-weight: 400;
  text-transform: capitalize;
}
</style>
